import { useEffect } from 'react';

const RobotsTxt = () => {
  useEffect(() => {
    // Remove all styling and set document to plain text mode
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.fontFamily = 'monospace';
    document.body.style.whiteSpace = 'pre';
    document.body.style.fontSize = '12px';
    document.body.style.lineHeight = '1.4';
    document.body.style.color = '#000';
    document.body.style.backgroundColor = '#fff';
    
    // Hide all other elements
    const allElements = document.querySelectorAll('*:not(#root):not(#root *)');
    allElements.forEach(el => {
      if (el !== document.body && el !== document.documentElement) {
        (el as HTMLElement).style.display = 'none';
      }
    });
    
    return () => {
      // Reset styles on cleanup
      document.body.style.cssText = '';
    };
  }, []);

  const robotsContent = `# SeniorThrive.com Robots.txt
# Comprehensive crawling instructions for search engines

# Allow all crawlers full access
User-agent: *
Allow: /

# Disallow admin and internal pages
Disallow: /admin/
Disallow: /api/
Disallow: /_internal/
Disallow: /preview/
Disallow: /test/
Disallow: /temp/
Disallow: /thank-you/
Disallow: /confirmation/
Disallow: /success/

# Sitemaps
Sitemap: https://seniorthrive.com/sitemap.xml
Sitemap: https://seniorthrive.com/blog-sitemap.xml`;

  return (
    <pre style={{ 
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'pre',
      color: '#000',
      backgroundColor: '#fff',
      border: 'none',
      outline: 'none'
    }}>
      {robotsContent}
    </pre>
  );
};

export default RobotsTxt;